export const ResultSummaryTypes = {
    SUM: "sum",
    AVG: "avg",
    NONE: "none",
    CUSTOM: "custom"
};